import Vue from "vue";
import {
  BooksService,
  DynamicService
} from "@/common/api.service";

import {
  BOOK_PUBLISH,
  BOOK_EDIT,
  BOOK_DELETE,
  BOOK_RESET_STATE,
  CONTENT_PUBLISH,
  CONTENT_DELETE,
  FETCH_BOOK,
  FETCH_BOOKS,
  FETCH_BOOKS_COUNT,
  SEARCH_BOOKS
} from "./actions.type";

import {
  RESET_STATE,
  SET_BOOK,
  APPEND_BOOKS,
  SET_BOOKS_COUNT,
  FETCH_START_BOOKS,
  FETCH_END_BOOKS,
} from "./mutations.type";

const initialState = {
  book: {
    BookNr: "",
    SeriesNr: "",
    urls: [],
    published: true,
    isbns: [],
    variants: [],
    image: {
      data: "",
      showInPost: false,
      description: ""
    },
    content: [],
    productSlug: "",
    linkedProduct: {
      slug: "",
      name: "",
      link: "",
      image: ""
    },
    secondLinkedProduct: {
      slug: "",
      name: "",
      link: "",
      image: ""
    },
    author: {
      slug: "",
      name: {
        title: "",
        name: "",
        surname: ""
      },
    },
    category: ""
  },
  books: [],
  isLoading: true,
  booksCount: 0
};

const defaultParamsBook = {
  include: [
    {
      relation: "variants",
      scope: {
        include: {
          relation: "model",
          scope: {
            include: "manufacturer"
          }
        }
      }
    },
    "author",
    "linkedProduct",
    "secondLinkedProduct",
    "content"
  ]
}

const defaultParamsBooks = {
  include: [
    {
      relation: "variants",
      scope: {
        include: {
          relation: "model"
        }
      }
    }
  ],
  fields: {
    urls: false,
    isLightTheme: false,
    createdAt: false,
    updatedAt: false,
    image: false,
  }
}

export const state = { ...initialState };

export const actions = {
  async [FETCH_BOOKS]({ commit }, params) {
    commit(FETCH_START_BOOKS);
    if (params == undefined) {
      params = defaultParamsBooks;
    }

    // do for loop
    const { data } = await BooksService.get('count');
    var count = data.count
    var batch = 8
    var currentBooks = 0

    while (currentBooks < count) {
      params.limit = batch
      params.skip = currentBooks
      BooksService.query(params)
      .then(({ data }) => {
        commit(APPEND_BOOKS, data);
      })
      .catch(error => {
        throw new Error(error);
      });
      currentBooks += batch
    }
    commit(FETCH_END_BOOKS);

    return

    // return BooksService.query(params)
    //   .then(({ data }) => {
    //     commit(FETCH_END_BOOKS, data);
    //   })
    //   .catch(error => {
    //     throw new Error(error);
    //   });
  },
  async [FETCH_BOOKS_COUNT](context) {
    const { data } = await BooksService.get('count');
    context.commit(SET_BOOKS_COUNT, data.count);
    return data.count
  },
  async [SEARCH_BOOKS](context, params) {
    return new Promise(async (resolve, reject) => {
      if (params == undefined) {
        params = defaultParamsBooks;
      }

      params.limit = 9

        console.log("params")
        console.log(params)
      BooksService.query(params)
      .then(({ data }) => {
        console.log("data")
        console.log(data)
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
    })
  },
  async [FETCH_BOOK](context, { slug, prevBook, params}) {
    // avoid extronuous network call if book exists
    if (prevBook !== undefined) {
      return context.commit(SET_BOOK, prevBook);
    }

    // Check for old Slug
    if (!slug.includes("-")) {
      if (slug.length <= 3) {
        slug += "-1"
      }
    }

    // console.log(context)
    if (params == undefined) {
      params = defaultParamsBook;
    }

    const { data } = await BooksService.get(slug, params);

    if (!data.linkedProduct) {
      data.linkedProduct = {
        slug: "",
        name: "",
        link: "",
        image: ""
      }
    }
    if (!data.secondLinkedProduct) {
      data.secondLinkedProduct = {
        slug: "",
        name: "",
        link: "",
        image: ""
      }
    }
    if (!data.linkedBook) {
      data.linkedBook = {
        slug: "",
        title: "",
        previewImage: ""
      }
    }
    if (!data.category) {
      data.category = ""
    }
    if (!data.variants) {
      data.variants = []
    }

    context.commit(SET_BOOK, data);
    return data;
  },
  [BOOK_PUBLISH]({ state }) {
    console.log("in BOOK_PUBLISH")

    // Variant-Link
    var postCarVariants = []
    for (var variant of state.book.variants) {
      postCarVariants.push({
        variantSlug: variant.slug,
        postSlug: state.book.slug
      })
    }
    console.log(postCarVariants)
    DynamicService.create("PostCarVariants", postCarVariants);

    console.log("before Book")
    // Book
    BooksService.create(state.book);

    console.log("before Content")
    // Content
    return BooksService.createRelated(state.book.slug + "/content", state.book.content);
  },
  [BOOK_DELETE](context, slug) {
    BooksService.destroy(slug + "/content");
    BooksService.destroy(slug + "/variants");
    return BooksService.destroy(slug);
  },
  async [BOOK_EDIT]({ state }) {
    console.log("in BOOK_EDIT")
    console.log(state.book)

    // Variant-Link
    BooksService.update(state.book.slug, state.book);
    await BooksService.destroy(state.book.slug + "/variants");
    var postCarVariants = []
    for (var variant of state.book.variants) {
      postCarVariants.push({
        variantSlug: variant.slug,
        postSlug: state.book.slug
      })
    }

    console.log(postCarVariants)
    // Book
    DynamicService.create("PostCarVariants", postCarVariants);

    // Content
    await BooksService.destroy(state.book.slug + "/content");
    return BooksService.createRelated(state.book.slug + "/content", state.book.content);
  },
  [BOOK_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [FETCH_START_BOOKS](state) {
    state.isLoading = true;
  },
  [FETCH_END_BOOKS](state) {
    state.isLoading = false;
  },
  [APPEND_BOOKS](state, books) {
    for (const book of books) {
      let shouldAdd = true
      for (let i in state.books) {
        const currentBook = state.books[i];
        if (book.slug == currentBook.slug) {
          shouldAdd = false;
        }
      }
      if(shouldAdd) {
        state.books.push(book);
      }
    }
  },
  [SET_BOOK](state, book) {
    state.book = book;
  },
  [SET_BOOKS_COUNT](state, count) {
    state.booksCount = count;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  }
};

const getters = {
  defaultParamsBooks() {
    return JSON.parse(JSON.stringify(defaultParamsBooks))
  },
  book(state) {
    // console.log("state.book");
    // console.log(state.book);
    return state.book;
  },
  booksCount(state) {
    return state.booksCount;
  },
  books(state) {
    return state.books;
  },
  isLoadingBooks(state) {
    return state.isLoading;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
